import ReactDOM from 'react-dom/client'
import { CustomProvider } from 'rsuite';
import frFr from 'rsuite/locales/fr_FR';
import enUs from 'rsuite/locales/en_US';
import App from './components/App'
import 'rsuite/dist/rsuite.min.css';
import './i18n';
import { useState, useEffect } from 'react';

function AppWrapper() {
  const [locale, setLocale] = useState(frFr); // Default to French

  useEffect(() => {
    const handleLanguageChange = (event) => {
      const newLang = event.detail;
      setLocale(newLang === 'fr' ? frFr : enUs);
    };

    window.addEventListener('languageChange', handleLanguageChange);
    
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  return (
    <CustomProvider locale={locale}>
      <App/>
    </CustomProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<AppWrapper />)